var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from "react";
import { Card } from "../Card";
/**
 * Active tab context, providing the active tab and the set function.
 */
export const ActiveTabContext = React.createContext({});
/**
 * Tab card style, providing flexible display and handling responsiveness.
 */
const style = {
    display: "flex",
    // For small resolutions we keep tabs, on the top
    flexDirection: ["column", "row"],
    overflow: "hidden",
};
const horizontalStyle = Object.assign(Object.assign({}, style), { flexDirection: "column" });
/**
 * Tabs container.
 */
export const Tabs = (_a) => {
    var { children, selected, isHorizontal } = _a, props = __rest(_a, ["children", "selected", "isHorizontal"]);
    const [tabList, ...tabPanels] = children;
    // Handling single tab special case, where children is a single element.
    const [firstTab] = Array.isArray(tabList.props.children) ? tabList.props.children : [tabList.props.children];
    const selectedTab = Array.isArray(tabList.props.children)
        ? tabList.props.children.find((tab) => tab.props.controls === selected)
        : false;
    const [active, setActive] = useState((selectedTab || firstTab).props.controls);
    const value = useMemo(() => ({ active, setActive }), [active]);
    return (React.createElement(Card, Object.assign({ "data-testid": "Tabs", sx: isHorizontal ? horizontalStyle : style }, props),
        React.createElement(ActiveTabContext.Provider, { value: value }, React.cloneElement(tabList, { isHorizontal })),
        tabPanels.filter((tabPanel) => tabPanel.props.id === active)));
};
